// Global utility functions
window.liquidIsMobile = function () {
  return (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent,
    ) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 0) ||
    navigator.platform === "iPad"
  );
};

if (window.liquidIsMobile()) {
  document.documentElement.classList.add("vc_mobile");
}

window.liquidWindowWidth = () => window.innerWidth;
window.liquidWindowHeight = () => window.innerHeight;

window.liquidSlugify = function (str) {
  return String(str)
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9 -]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");
};

window.liquidDebounce = function (func, wait, immediate) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      timeout = null;
      if (!immediate) func.apply(this, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(this, args);
  };
};

window.liquidGetMousePos = (ev, basedOnElement) => {
  let posx = 0;
  let posy = 0;
  if (!ev) ev = window.event;
  if (ev.pageX || ev.pageY) {
    posx = ev.pageX;
    posy = ev.pageY;
  } else if (ev.clientX || ev.clientY) {
    posx =
      ev.clientX +
      document.body.scrollLeft +
      document.documentElement.scrollLeft;
    posy =
      ev.clientY + document.body.scrollTop + document.documentElement.scrollTop;
  }
  if (basedOnElement) {
    const rect = ev.currentTarget.getBoundingClientRect();
    posx = posx - rect.left - window.scrollX;
    posy = posy - rect.top - window.scrollY;
  }
  return { x: posx, y: posy };
};

class Hover3D {
  constructor(element) {
    this.element = element;
    this.hoverable = element.querySelector("[data-stacking-factor]");
    if (!this.hoverable) return;

    this.stackingFactor = parseFloat(
      this.hoverable.getAttribute("data-stacking-factor"),
    );
    this.rect = {};
    this.maxRotation = 8;
    this.maxTranslation = 4;
    this.init();
  }

  init() {
    new IntersectionObserver(([entry], observer) => {
      observer.disconnect();
      const { boundingClientRect } = entry;
      this.rect = {
        width: boundingClientRect.width,
        height: boundingClientRect.height,
      };
      this.bindEvents();
      this.element.classList.add("hover-3d-applied");
    }).observe(this.element);
  }

  bindEvents() {
    this.element.addEventListener("mousemove", this.onMouseMove.bind(this));
    this.element.addEventListener("mouseleave", this.onMouseLeave.bind(this));
    window.addEventListener("resize", this.onResize.bind(this));
  }

  async onResize() {
    await this.measure();
  }

  measure() {
    return new Promise((resolve) => {
      new IntersectionObserver(([entry], observer) => {
        observer.disconnect();
        this.rect = {
          width: entry.boundingClientRect.width,
          height: entry.boundingClientRect.height,
        };
        resolve();
      }).observe(this.element);
    });
  }

  animate(config, isIn) {
    if (isIn) {
      this.element.classList.add("mouse-in");
    } else {
      this.element.classList.remove("mouse-in");
    }

    this.hoverable.style.transition = "none";
    gsap.to(this.hoverable, {
      x: config.xTranslationPercentage * -1 * config.maxTranslationX,
      y: config.yTranslationPercentage * -1 * config.maxTranslationY,
      rotateX: config.xRotationPercentage * -1 * config.maxRotationX,
      rotateY: config.yRotationPercentage * -1 * config.maxRotationY,
      duration: 0.8,
      ease: "power2.out",
    });
  }

  calculatePercentage(offset, dimension) {
    return (-2 / dimension) * offset + 1;
  }

  onMouseMove(e) {
    const rect = this.element.getBoundingClientRect();
    const mouseOffset = {
      x: e.pageX - rect.left - window.scrollX,
      y: e.pageY - rect.top - window.scrollY,
    };

    const transVals = {
      xRotationPercentage: this.calculatePercentage(
        mouseOffset.y,
        this.rect.height,
      ),
      yRotationPercentage:
        this.calculatePercentage(mouseOffset.x, this.rect.width) * -1,
      xTranslationPercentage: this.calculatePercentage(
        mouseOffset.x,
        this.rect.width,
      ),
      yTranslationPercentage: this.calculatePercentage(
        mouseOffset.y,
        this.rect.height,
      ),
    };

    this.animate(
      {
        maxTranslationX: this.maxTranslation * this.stackingFactor,
        maxTranslationY: this.maxTranslation * this.stackingFactor,
        maxRotationX: this.maxRotation * this.stackingFactor,
        maxRotationY: this.maxRotation * this.stackingFactor,
        ...transVals,
      },
      true,
    );
  }

  onMouseLeave() {
    this.animate(
      {
        maxTranslationX: 0,
        maxTranslationY: 0,
        maxRotationX: 0,
        maxRotationY: 0,
        xRotationPercentage: 0,
        yRotationPercentage: 0,
        xTranslationPercentage: 0,
        yTranslationPercentage: 0,
      },
      false,
    );
  }

  destroy() {
    this.element.removeEventListener("mousemove", this.onMouseMove);
    this.element.removeEventListener("mouseleave", this.onMouseLeave);
    window.removeEventListener("resize", this.onResize);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  if (!window.liquidIsMobile()) {
    document.querySelectorAll("[data-hover3d]").forEach((el) => {
      new Hover3D(el);
    });
  }
});
